// extracted by mini-css-extract-plugin
export default {"leagueHead":"VStandings_leagueHead_3MD4S","root":"VStandings_root_3bxm-"};